import { css } from '@emotion/react';
import { useState } from 'react';
import t from 'react-translate';
import ClickableContainer from 'components/clickable-container';
import { MentoringProgramGuide } from 'redux/schemas/models/mentoring-program-guides';
import { halfSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';
import { gray7 } from 'styles/global_defaults/colors';
import { config } from '@config/pendo.config.json';
import GuidanceItem from './guidance-item';


const DEFAULT_DISPLAY_LIMIT = 2;

type GuidanceSectionProps = {
  guides: MentoringProgramGuide[];
  className?: string;
};

const styles = css`
  .guide-list {
    gap: ${halfSpacing}px;
  }

  .toggle-show-more {
    padding: ${quarterSpacing}px;
    border-radius: ${quarterSpacing}px;

    &:hover {
      background: ${gray7};
    }
  }
`;

const GuidanceSection = ({ guides, className }: GuidanceSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GUIDANCE_SECTION;
  const dataQATag = config.pendo.athena.mentorshipProgram.participantHome.guidance.section;

  return (
    <div css={styles} className={className}>
      <ul className='list-unstyled guide-list d-flex flex-wrap align-items-center'>
        {(isExpanded ? guides : guides.slice(0, DEFAULT_DISPLAY_LIMIT)).map(
          (guide) => (
            <li key={guide.id}>
              <GuidanceItem guide={guide} />
            </li>
          ),
        )}
        {guides.length > DEFAULT_DISPLAY_LIMIT && (
          <li key='toggle'>
            <ClickableContainer
              className='text-regular toggle-show-more semi-bold gray-2'
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded((expanded) => !expanded);
              }}
              data-qa={dataQATag.toggleExpand}
              aria-expanded={isExpanded}
              aria-label={
                isExpanded
                  ? translationBase.ARIA_LABEL.SHOW_LESS_GUIDES()
                  : translationBase.ARIA_LABEL.SHOW_MORE_GUIDES(guides.length - DEFAULT_DISPLAY_LIMIT)
              }
            >
              {isExpanded
                ? translationBase.SHOW_LESS()
                : translationBase.SHOW_MORE(guides.length - DEFAULT_DISPLAY_LIMIT)}
            </ClickableContainer>
          </li>
        )}
      </ul>
    </div>
  );
};

export default GuidanceSection;
